import React, { useEffect, useState } from "react";
import {
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";
import Select from "react-select";
import CountriesService from "services/Admin/CountriesService";
import AreasService from "services/Admin/AreasService";
import { useSelector } from "react-redux";

const FilterForm = ({ showFilters, setCountryId, setLocationId, setShowFilters }) => {
    const countriesService = new CountriesService()
    const areaService = new AreasService()
    const [country, setCountry] = useState([])
    const [location, setLocation] = useState([])
    const [options, setOptions] = useState([])
    const [locationOptions, setLocationOptions] = useState([])
    const filterData = useSelector(state => state.adminFilter)
    
    useEffect(() => {
        if (!!filterData.country?.value) {
            setCountry(filterData.country)
        } else {
            setCountry(null)
        }

        if (filterData.location?.length > 0) {
            setLocation([...filterData.location])
        } else {
            setLocation(null)
        }
    }, [])

    useEffect(() => {
        countriesService.getDropDown().then(res => {
            const newOptions = res?.data?.map(item => {
                return {
                    label: item.name.en,
                    value: item.id
                }
            })
            setOptions(newOptions)
        })
    }, [])

    useEffect(()=>{
        if(!!country?.value){
          areaService.getAreasDropDown(country.value).then(res => {
            const data = res.data?.map(item => {
                return {
                    name: item.name,
                    label: item.name.en,
                    value: item.id
                }
            })
            setLocationOptions(data)
          })
        }
      },[country])

    const handleValidSubmit = () => {
        setCountryId(country)
        setLocationId(location)
        setShowFilters(false)
        setShowFilters(!showFilters)
    }
    return (
        <Modal isOpen={showFilters} toggle={() => setShowFilters(!showFilters)}
            className="rightModalSide scrollbar-container mt-0" >
            <ModalHeader toggle={() => setShowFilters(!showFilters)}>
                Developer Filters
            </ModalHeader>
            <ModalBody>
                <Col md={12}>
                    <label>Countries</label>
                    <Select
                        placeholder={"Select"}
                        options={options}
                        onChange={(data) => {
                            setCountry(data)
                            setLocation(null)
                        }}
                        value={country}
                    />
                </Col>
                <Col md={12} className='mt-3'>
                    <label>Location</label>
                    <Select
                        placeholder={"Select"}
                        options={locationOptions}
                        noOptionsMessage={() => {
                            if(country?.length == 0 || !country){
                                return "Choose Country First"
                            }
                        }}
                        onChange={(data) => {
                            setLocation(data)
                        }}
                        value={location}
                        isMulti={true}
                    />
                </Col>
            </ModalBody>
            <ModalFooter className="mt-4 px-0 d-flex justify-content-between">
                <button
                    type='button'
                    className='btn btn-light w-120'
                    onClick={() => {
                        setCountryId(null)
                        setCountry(null)
                        setLocation(null)
                        setLocationId(null)
                    }}>
                    Reset Filter
                       </button>
                <button type='button'
                    onClick={() => handleValidSubmit()}
                    className='btn btn-success  w-120'>
                    Apply Filter
                    </button>
            </ModalFooter>
        </Modal>
    )
}

export default FilterForm

